var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "my-courses my-courses--tiles",
    },
    [
      _vm._l(_vm.groups, function (group, index) {
        return [
          _c(
            "div",
            {
              key: index,
              staticClass: "group-label",
            },
            [_vm._v(_vm._s(group.name))]
          ),
          _vm._v(" "),
          _vm._l(group.data, function (subgroup) {
            return _c(
              "article",
              {
                key: subgroup.id,
                staticClass: "studip",
                class: _vm.getGroupCssClasses(subgroup),
              },
              [
                subgroup.label
                  ? _c("header", [
                      _c("h1", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "#",
                            },
                            on: {
                              click: function click($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.toggleOpenGroup(subgroup)
                              },
                            },
                          },
                          [_vm._v(_vm._s(subgroup.label))]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "studip-grid",
                  },
                  [
                    _vm._l(
                      _vm.getOrderedCourses(subgroup.ids),
                      function (course) {
                        return [
                          _vm.isParent(course)
                            ? _c(
                                "div",
                                {
                                  key: course.id,
                                  staticClass: "course-group-label",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.getCourseName(
                                          course,
                                          _vm.getConfig("sem_number")
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "article",
                            {
                              key: course.id,
                              staticClass: "studip-grid-element",
                              class: _vm.getCourseCssClasses(course),
                              attrs: {
                                "data-course-id": course.id,
                              },
                            },
                            [
                              _c(
                                "header",
                                {
                                  staticClass: "tiles-grid-element-header",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tiles-grid-element-options",
                                    },
                                    [
                                      _c("studip-action-menu", {
                                        staticClass: "tiles-action-menu",
                                        attrs: {
                                          items: _vm.getActionMenuForCourse(
                                            course,
                                            true
                                          ),
                                          collapseAt: 0,
                                        },
                                        on: {
                                          "show-color-picker":
                                            function showColorPicker($event) {
                                              _vm.shownColorPicker = course.id
                                            },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "tiles-grid-element-header-content",
                                      attrs: {
                                        href: _vm.urlFor("seminar_main.php", {
                                          auswahl: course.id,
                                        }),
                                        title: _vm.getCourseName(
                                          course,
                                          _vm.getConfig("sem_number")
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "tiles-grid-element-header-image",
                                        style: {
                                          backgroundImage: "url(".concat(
                                            course.avatar,
                                            ")"
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tiled-grid-element-header-title",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.getCourseName(
                                                  course,
                                                  _vm.getConfig("sem_number")
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                          course.is_deputy
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext("[Vertretung]")
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  course.is_hidden
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "course-hidden-info",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$gettext("[versteckt]")
                                              ) +
                                              "\n                                "
                                          ),
                                          _c("studip-tooltip-icon", {
                                            attrs: {
                                              text: _vm.getHiddenTooltip(
                                                course
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "footer",
                                {
                                  staticClass: "tiles-grid-element-footer",
                                },
                                [
                                  _c("my-courses-navigation", {
                                    attrs: {
                                      navigation:
                                        _vm.getNavigationForCourse(course),
                                      "icon-size": _vm.iconSize,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showColorPickerForCourse(course)
                                ? _c("my-courses-color-picker", {
                                    attrs: {
                                      course: course,
                                    },
                                    on: {
                                      "color-picked": _vm.changeColor,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      }
                    ),
                  ],
                  2
                ),
              ]
            )
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }